// @ts-check
import React from "react"
import useReportFiltersContext from "../../../../../hooks/contextConsumers/useReportFiltersContext.hook"
import { Table } from "../../../../../components/table/Table.component"
import Card from "../../../../../components/atoms/Card.atom"
import {
  getCoreRowModel,
  getFilteredRowModel,
  useReactTable,
} from "@tanstack/react-table"
import { buildClientSprintsTableColumns } from "./ClientSprints.columns"
import { EmptyTableMessage } from "../../../../../components/compounds/customMessages/EmptyTableMessage.compound"
import { useClientSprintsTableData } from "./useClientSprintsTableData.hook"

/** @param {import("./ClientSprints.controller.types").ClientSprintsProps} params */
const ClientSprints = (params) => {
  const { selectedPeriod } = params

  const { clientReportSelectedClient } = useReportFiltersContext()

  const { sprintsData, loading } = useClientSprintsTableData(
    clientReportSelectedClient
  )

  const columns = buildClientSprintsTableColumns()

  const table = useReactTable({
    data: sprintsData,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    enableSorting: false,
  })

  /**
   * @param {import("./ClientSprints.controller.types").ClientSprintsTableRow} row
   */
  function getRowClassName(row) {
    const rowData = row.original

    if (selectedPeriod.sprintNumber === rowData.sprintNumberByClient) {
      return "highlighted-sprint-row"
    }

    return ""
  }

  return (
    <Card className="client-historic-card-container">
      <Table
        table={table}
        className="client-historic-sprints__table"
        isLoading={loading}
        estimatedRowHeight={() => 33}
        rowClassName={getRowClassName}
        emptyMessage={
          <EmptyTableMessage
            title="Nada por aquí (todavía)"
            message="No hay información de los sprints"
          />
        }
      />
    </Card>
  )
}

export default ClientSprints
